module.exports = __webpack_public_path__ + "img/recover.e0f7f75c.svg";